'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useDataTable } from './context';
import { NumericPagination } from '../navigation/NumericPagination/index';
import styles from './DataTable.module.css';
export function Pagination() {
    const { table } = useDataTable();
    const { pageIndex } = table.getState().pagination;
    const totalPages = table.getPageCount();
    if (totalPages <= 1)
        return null;
    return (_jsx("div", { className: styles.paginationSlot, children: _jsx(NumericPagination, { currentPage: pageIndex + 1, totalPages: totalPages, onPageChange: (page) => table.setPageIndex(page - 1) }) }));
}
//# sourceMappingURL=Pagination.js.map